import { useMutation, useQueryClient } from "@tanstack/react-query";
import { prequalSiteInheritApi } from "@/api/prequalSiteInherit";
import { prequalSiteAdminKeys } from "./prequalSiteAdminKeys";

/** Record that a staff member reviewed this broker's inherited prequalification
 *  site and kept it. Invalidates the record-scoped read so the broker's
 *  "Inheritance reviewed {date}" line refreshes. */
export function useConfirmPrequalSiteInheritance(brokerId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => prequalSiteInheritApi.confirm(brokerId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: prequalSiteAdminKeys.all });
    },
  });
}
